/* eslint-disable max-lines */
import { DrawerHeader, IconButton } from '@one-thd/sui-atomic-components';
import { ArrowBack, Close } from '@one-thd/sui-icons';
import React, { useEffect, useState } from 'react';
import { SubmitDeliveryAddressSuspendCart } from '../../../api/oms/edit-delivery-address';
import { FLOW_TYPES } from '../../../constants/out-of-stock';
import { EditDeliveryAddressChangeForm } from './EditDeliveryAddressChangeForm';
import { EditDeliveryAddressDeliveryDetails } from './EditDeliveryAddressDeliveryDetails';
import { EditDeliveryAddressConfirmation } from './EditDeliveryAddressConfirmation';
import { EditDeliveryAddressSurvey } from './EditDeliveryAddressSurvey';
import { EditDeliveryAddressConfirmationBODFS } from './BodfsConfirmation/EditDeliveryAddressConfirmationBODFS';
import { getWindow } from '../../../utils/general';
import { useOrderContext, useFulfillmentGroupContext, useEditDeliveryAddressContext, useEditDeliveryInstructionsContext, } from '../../../hooks/useContexts';
import { extractAddressFromFulfillmentGroup } from '../../../utils/order-details/OrderDetailsUtils';
import { FULFILLMENT_TYPE } from '../../../constants/status';
import { getFlowTypeValue } from '../util/OutOfStock';
import { getCookieValue } from '../../../utils/cookie-helper';
import { mapLineIds, goBackToChangeForm, goBackToDeliveryDetails, goBackToDeliveryOptions, } from '../../../utils/edit-delivery-address/editDeliveryAddressUtils';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { TrackBopisOosrAnalytics } from '../../../utils/bopis/bopis-oosr-analytics';
import { EditDeliveryAddressDeliveryOptions } from './EditDeliveryAddressDeliveryOptions';
export var EditDeliveryAddressDrawerContent = function (_a) {
    var _b, _c, _d, _e;
    var setOpen = _a.setOpen, isBopisOutOfStock = _a.isBopisOutOfStock, isOuterClick = _a.isOuterClick, setIsOuterClick = _a.setIsOuterClick;
    var _f = useFulfillmentGroupContext(), fulfillmentGroup = _f.fulfillmentGroup, fulfillmentType = _f.fulfillmentType;
    var _g = useOrderContext(), orderDetailsData = _g.orderDetailsData, orderId = _g.orderId, currentBopisOosDrawer = _g.currentBopisOosDrawer, setCurrentBopisOosDrawer = _g.setCurrentBopisOosDrawer;
    var _h = useEditDeliveryAddressContext(), _j = _h.formState, firstNameValue = _j.firstNameValue, lastNameValue = _j.lastNameValue, streetAddressValue = _j.streetAddressValue, addressLineTwoValue = _j.addressLineTwoValue, zipCodeValue = _j.zipCodeValue, cityStateValue = _j.cityStateValue, phoneNumberValue = _j.phoneNumberValue, updateFormField = _h.updateFormField, setShowCalendar = _h.setShowCalendar, setRequireSignature = _h.setRequireSignature;
    var setDeliveryInstructions = useEditDeliveryInstructionsContext().setDeliveryInstructions;
    var _k = useState(true), isChangeForm = _k[0], setIsChangeForm = _k[1];
    var _l = useState(false), isDeliveryDetails = _l[0], setIsDeliveryDetails = _l[1];
    var _m = useState(false), isConfirmation = _m[0], setIsConfirmation = _m[1];
    var _o = useState(false), isSurvey = _o[0], setIsSurvey = _o[1];
    var _p = useState(Boolean(FeatureSwitches.enableEditDeliveryAddressAppify)), isAddressList = _p[0], setIsAddressList = _p[1];
    var _q = useState(false), isDeliveryOptions = _q[0], setIsDeliveryOptions = _q[1];
    var _r = useState(null), selectedDeliveryOptionType = _r[0], setSelectedDeliveryOptionType = _r[1];
    // Stores info for re-load of OD page in session storage to determine what (if any) Alerts to render
    var _s = useState(), editDeliveryAddressAlert = _s[0], setEditDeliveryAddressAlert = _s[1];
    var _t = useState(), suspendCartData = _t[0], setSuspendCartData = _t[1];
    var _u = useState(false), isAddressChangeConfirmed = _u[0], setIsAddressChangeConfirmed = _u[1];
    var _v = useState(), updatedAddressData = _v[0], setUpdatedAddressData = _v[1];
    var _w = useState({}), newDeliveryAddressDetails = _w[0], setNewDeliveryAddressDetails = _w[1];
    // Change Form values (stored here as any change made needs to be retained while in flow)
    var _x = extractAddressFromFulfillmentGroup(fulfillmentGroup.shippingAndHandling ||
        fulfillmentGroup.storePickup ||
        fulfillmentGroup.bodfsDeliveryAndHandling, fulfillmentType), firstName = _x.firstName, lastName = _x.lastName, addressLine1 = _x.addressLine1, addressLine2 = _x.addressLine2, zipCode = _x.zipCode, city = _x.city, state = _x.state, phoneNumber = _x.phoneNumber, country = _x.country;
    var _y = useState(false), isDefaultValue = _y[0], setIsDefault = _y[1];
    var _z = useState(false), isLoading = _z[0], setIsLoading = _z[1];
    var _0 = useState(false), isExcludedAddress = _0[0], setIsExcludedAddress = _0[1];
    var _1 = useState(true), isValidated = _1[0], setIsValidated = _1[1];
    var _2 = useState(false), submitCreateForm = _2[0], setSubmitCreateForm = _2[1];
    var _3 = useState(''), validationEt = _3[0], setValidationEt = _3[1];
    var resetBodfsFlow = function () {
        setDeliveryInstructions('');
        setShowCalendar(false);
        setRequireSignature(false);
    };
    var flowType = getFlowTypeValue(currentBopisOosDrawer, FLOW_TYPES.EDIT_DELIVERY_ADDRESS);
    var deliveryAddressCreateCartRequestData = {
        orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
        firstName: firstNameValue,
        lastName: lastNameValue,
        phoneNumber: phoneNumberValue,
        emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
        fulfillmentType: ((_b = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || '',
        originalFulfillmentType: ((_c = convertedFulfillmentTypes(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType)) === null || _c === void 0 ? void 0 : _c.toUpperCase()) || '',
        newFulfillmentType: ((_d = convertedFulfillmentTypes(selectedDeliveryOptionType)) === null || _d === void 0 ? void 0 : _d.toUpperCase()) || null,
        storeId: (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentStore) || '',
        lineIds: (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems)
            ? mapLineIds(fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems)
            : [],
        newDeliveryAddress: {
            addressLine1: streetAddressValue || '',
            addressLine2: addressLineTwoValue || null,
            city: cityStateValue.split(',')[0],
            state: (_e = cityStateValue === null || cityStateValue === void 0 ? void 0 : cityStateValue.split(',')[1]) === null || _e === void 0 ? void 0 : _e.trim(),
            zipCode: zipCodeValue,
            country: country,
        },
        forterToken: getCookieValue('forterToken') || '',
        net: (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net) || '',
        et: validationEt || '',
        flowType: flowType,
    };
    var setChangeFormValues = function () {
        if (!currentBopisOosDrawer) {
            updateFormField({
                firstNameValue: firstName,
                lastNameValue: lastName,
                streetAddressValue: addressLine1,
                addressLineTwoValue: addressLine2,
                zipCodeValue: zipCode,
                cityStateValue: "".concat(city, ", ").concat(state),
            });
        }
        updateFormField({ phoneNumberValue: phoneNumber });
    };
    var suspendCartCheck = function () {
        if (suspendCartData && !isAddressChangeConfirmed) {
            SubmitDeliveryAddressSuspendCart(suspendCartData, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId);
            setSuspendCartData(undefined);
        }
    };
    // Handles all logic associated with closing drawer
    // Should always be invoked instead of directly invoking setOpen(false)
    var closeDrawer = function () {
        var _a, _b;
        resetBodfsFlow();
        // Reset outer click
        setIsOuterClick(false);
        if (currentBopisOosDrawer) {
            setCurrentBopisOosDrawer('');
        }
        setOpen(false);
        suspendCartCheck();
        setIsConfirmation(false);
        setIsSurvey(false);
        if (isAddressChangeConfirmed) {
            setIsAddressChangeConfirmed(false);
            (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.reload();
        }
        else {
            setChangeFormValues();
        }
    };
    var goBack = function () {
        if (isChangeForm) {
            // Back to the address list when feature is enabled
            if (FeatureSwitches.enableEditDeliveryAddressAppify && !isAddressList) {
                setIsAddressList(true);
                return;
            }
            resetBodfsFlow();
            // Back to review your options
            if (currentBopisOosDrawer) {
                setCurrentBopisOosDrawer('');
                return;
            }
        }
        if (isConfirmation) {
            goBackToDeliveryDetails(suspendCartCheck, setIsChangeForm, setIsConfirmation, setIsDeliveryDetails);
            return;
        }
        // STH or BODFS flow
        if (FeatureSwitches.isSFBLEnabled &&
            !currentBopisOosDrawer &&
            isDeliveryDetails) {
            resetBodfsFlow();
            goBackToDeliveryOptions(suspendCartCheck, setIsDeliveryOptions, setIsDeliveryDetails);
            return;
        }
        if (isDeliveryDetails) {
            resetBodfsFlow();
            goBackToChangeForm(suspendCartCheck, setIsChangeForm, setSubmitCreateForm, setIsConfirmation, setIsDeliveryDetails);
            return;
        }
        if (isDeliveryOptions) {
            goBackToChangeForm(suspendCartCheck, setIsChangeForm, setSubmitCreateForm, setIsConfirmation, setIsDeliveryDetails);
            setIsDeliveryOptions(false);
            setIsLoading(false);
            return;
        }
        closeDrawer();
    };
    useEffect(function () {
        var _a;
        if (editDeliveryAddressAlert) {
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('editDeliveryAddressAlert', JSON.stringify(editDeliveryAddressAlert));
        }
    }, [editDeliveryAddressAlert]);
    useEffect(function () {
        var _a;
        if (currentBopisOosDrawer === 'STH_DELIVERY_OPTION') {
            TrackBopisOosrAnalytics('out of stock review your options: switch to delivery', 'overlay');
        }
        setChangeFormValues();
        var onBeforeUnload = function () {
            suspendCartCheck();
        };
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.addEventListener('beforeunload', onBeforeUnload);
        return function () {
            var _a;
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.removeEventListener('beforeunload', onBeforeUnload);
            suspendCartCheck();
        };
    }, []);
    useEffect(function () {
        var _a, _b, _c;
        if (updatedAddressData) {
            setSuspendCartData({
                cartId: updatedAddressData.ordersInfo.data.newOrder.cartId,
                orderId: orderId,
                emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
                net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
                flowType: flowType,
                fulfillmentType: ((_a = convertedFulfillmentTypes(fulfillmentType)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) ||
                    undefined,
                originalFulfillmentType: ((_b = convertedFulfillmentTypes(fulfillmentGroup.fulfillmentType)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || undefined,
                newFulfillmentType: ((_c = convertedFulfillmentTypes(selectedDeliveryOptionType)) === null || _c === void 0 ? void 0 : _c.toUpperCase()) || null,
            });
        }
    }, [updatedAddressData]);
    useEffect(function () {
        if (isOuterClick) {
            closeDrawer();
        }
    }, [isOuterClick]);
    var handleDrawerHeader = function () {
        if (isConfirmation) {
            return 'Confirm Delivery Address';
        }
        if (isDeliveryDetails) {
            return 'Delivery Details';
        }
        if (isBopisOutOfStock) {
            return isAddressList
                ? 'Choose Delivery Address'
                : 'Add New Delivery Address';
        }
        if (isChangeForm && FeatureSwitches.enableEditDeliveryAddressAppify) {
            return isAddressList
                ? 'Choose New Delivery Address'
                : 'Add New Delivery Address';
        }
        if (isDeliveryOptions && FeatureSwitches.isSFBLEnabled) {
            return 'Delivery Options';
        }
        return 'Edit Delivery Address';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerHeader, { title: handleDrawerHeader(), endAdornment: React.createElement(IconButton, { "aria-label": "drawer-close", onClick: function () { return closeDrawer(); }, icon: Close }), startAdornment: (!isChangeForm ||
                currentBopisOosDrawer ||
                (FeatureSwitches.enableEditDeliveryAddressAppify &&
                    !isAddressList)) &&
                !isSurvey && (React.createElement(IconButton, { "aria-label": "go-back", onClick: function () { return goBack(); }, icon: ArrowBack })) }),
        isChangeForm && (React.createElement(EditDeliveryAddressChangeForm, { previousCountry: country || '', closeDrawer: closeDrawer, setIsChangeForm: setIsChangeForm, setIsDeliveryDetails: setIsDeliveryDetails, setUpdatedAddressData: setUpdatedAddressData, setNewDeliveryAddressDetails: setNewDeliveryAddressDetails, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, setIsAddressList: setIsAddressList, isAddressList: isAddressList, isDefaultValue: isDefaultValue, setIsDefault: setIsDefault, setIsLoading: setIsLoading, isLoading: isLoading, isExcludedAddress: isExcludedAddress, setIsExcludedAddress: setIsExcludedAddress, isValidated: isValidated, setIsValidated: setIsValidated, deliveryAddressCreateCartRequestData: deliveryAddressCreateCartRequestData, submitCreateForm: submitCreateForm, setSubmitCreateForm: setSubmitCreateForm, validationEt: validationEt, setValidationEt: setValidationEt, setIsDeliveryOptions: setIsDeliveryOptions })),
        isDeliveryDetails && (React.createElement(EditDeliveryAddressDeliveryDetails, { updatedAddressData: updatedAddressData, setUpdatedAddressData: setUpdatedAddressData, newDeliveryAddressDetails: newDeliveryAddressDetails, setIsChangeForm: setIsChangeForm, setIsConfirmation: setIsConfirmation, setIsDeliveryDetails: setIsDeliveryDetails, isDeliveryDetails: isDeliveryDetails, suspendCartCheck: suspendCartCheck, setIsLoading: setIsLoading, setIsExcludedAddress: setIsExcludedAddress, setIsValidated: setIsValidated, closeDrawer: closeDrawer, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, traceId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId, deliveryAddressCreateCartRequestData: deliveryAddressCreateCartRequestData, resetBodfsFlow: resetBodfsFlow, selectedDeliveryOptionType: selectedDeliveryOptionType })),
        isConfirmation &&
            updatedAddressData &&
            ((selectedDeliveryOptionType !== null && selectedDeliveryOptionType !== void 0 ? selectedDeliveryOptionType : fulfillmentGroup.fulfillmentType) ===
                FULFILLMENT_TYPE.BODFS ? (React.createElement(EditDeliveryAddressConfirmationBODFS, { closeDrawer: closeDrawer, updatedAddressData: updatedAddressData, newDeliveryAddressDetails: newDeliveryAddressDetails, setIsChangeForm: setIsChangeForm, setIsConfirmation: setIsConfirmation, setIsSurvey: setIsSurvey, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, suspendCartCheck: suspendCartCheck, setIsAddressChangeConfirmed: setIsAddressChangeConfirmed, setIsDeliveryDetails: setIsDeliveryDetails, setSubmitCreateForm: setSubmitCreateForm, resetBodfsFlow: resetBodfsFlow, selectedDeliveryOptionType: selectedDeliveryOptionType })) : (React.createElement(EditDeliveryAddressConfirmation, { closeDrawer: closeDrawer, updatedAddressData: updatedAddressData, newDeliveryAddressDetails: newDeliveryAddressDetails, setIsChangeForm: setIsChangeForm, setIsConfirmation: setIsConfirmation, setIsSurvey: setIsSurvey, isDeliveryDetails: isDeliveryDetails, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, suspendCartCheck: suspendCartCheck, setIsAddressChangeConfirmed: setIsAddressChangeConfirmed, resetBodfsFlow: resetBodfsFlow, selectedDeliveryOptionType: selectedDeliveryOptionType }))),
        isDeliveryOptions && FeatureSwitches.isSFBLEnabled && (React.createElement(EditDeliveryAddressDeliveryOptions, { closeDrawer: closeDrawer, deliveryAddressCreateCartRequestData: deliveryAddressCreateCartRequestData, newDeliveryAddressDetails: newDeliveryAddressDetails, isAddingNewAddress: Boolean(FeatureSwitches.enableEditDeliveryAddressAppify) &&
                !isAddressList, isDefaultValue: isDefaultValue, isLoading: isLoading, setIsChangeForm: setIsChangeForm, setIsDeliveryOptions: setIsDeliveryOptions, setIsDeliveryDetails: setIsDeliveryDetails, setIsLoading: setIsLoading, setIsExcludedAddress: setIsExcludedAddress, setIsValidated: setIsValidated, setUpdatedAddressData: setUpdatedAddressData, setEditDeliveryAddressAlert: setEditDeliveryAddressAlert, setSelectedDeliveryOptionType: setSelectedDeliveryOptionType })),
        isSurvey && (React.createElement(EditDeliveryAddressSurvey, { closeDrawer: closeDrawer, selectedDeliveryOptionType: selectedDeliveryOptionType, newOrderId: editDeliveryAddressAlert === null || editDeliveryAddressAlert === void 0 ? void 0 : editDeliveryAddressAlert.newOrderId, isBopisOutOfStock: isBopisOutOfStock }))));
};
